const getDoesCommentExist = (commentId, documents) => {
    var _a;
    for (let docIndex = 0; docIndex < documents.length; docIndex++) {
        const classifications = documents[docIndex].classifications;
        for (let classIndex = 0; classIndex < classifications.length; classIndex++) {
            if ((_a = classifications[classIndex].comments) === null || _a === void 0 ? void 0 : _a.find(x => x.id === commentId)) {
                return true;
            }
        }
    }
    return false;
};
export default getDoesCommentExist;
